var _title, _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGauge4(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 165,
    viewBox: "0 0 266 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Engagement Score Gauge at level 4 out of 5")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8456 7.03948C88.0065 7.63461 86.998 9.60795 87.5932 11.447C88.1883 13.2861 90.1616 14.2946 92.0007 13.6994C117.919 5.31225 145.835 5.39661 171.702 13.9403C173.538 14.5465 175.517 13.55 176.123 11.7146C176.73 9.87908 175.733 7.89969 173.898 7.29345C146.618 -1.71658 117.179 -1.80555 89.8456 7.03948ZM179.766 12.8743C180.545 11.1049 182.61 10.3013 184.379 11.0795C210.677 22.6448 232.609 42.2841 246.995 67.1509C247.963 68.8241 247.392 70.9652 245.719 71.9332C244.046 72.9012 241.904 72.3295 240.936 70.6564C227.294 47.0767 206.498 28.4539 181.561 17.4872C179.792 16.709 178.988 14.6438 179.766 12.8743ZM247.41 74.9148C249.161 74.0948 251.244 74.849 252.064 76.5995C264.252 102.615 267.838 131.835 262.303 160.026C261.931 161.923 260.091 163.158 258.195 162.786C256.298 162.414 255.062 160.574 255.434 158.677C260.683 131.946 257.282 104.238 245.726 79.569C244.906 77.8186 245.66 75.7348 247.41 74.9148ZM17.5718 71.201C15.9097 70.214 15.3625 68.0666 16.3496 66.4046C31.0187 41.7033 53.1728 22.3153 79.6008 11.0504C81.379 10.2925 83.435 11.1196 84.1929 12.8978C84.9509 14.676 84.1238 16.7319 82.3456 17.4899C57.2855 28.1716 36.2781 46.5562 22.3682 69.9788C21.3812 71.6409 19.2338 72.1881 17.5718 71.201ZM4.51394 159.988C4.96076 161.869 6.84754 163.031 8.72819 162.584C10.6088 162.137 11.7712 160.251 11.3244 158.37C5.02739 131.866 7.33413 104.046 17.9102 78.9407C18.6607 77.1593 17.8249 75.1069 16.0436 74.3564C14.2622 73.606 12.2097 74.4417 11.4593 76.2231C0.305896 102.698 -2.12675 132.037 4.51394 159.988Z",
    fill: "url(#paint0_radial_590_35662)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_590_35662)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 217.585,
    cy: 35.585,
    r: 10.5391,
    transform: "rotate(0.25 217.585 35.585)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.585,
    cy: 35.585,
    r: 10.5391,
    transform: "rotate(0.25 217.585 35.585)",
    stroke: "#EB9780",
    strokeWidth: 7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_590_35662",
    x: 181.589,
    y: 12.7633,
    width: 71.9911,
    height: 71.9911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.3913
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.3913
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_590_35662"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1739
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.9783
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_590_35662",
    result: "effect2_dropShadow_590_35662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_590_35662",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_590_35662",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.50001 163.627) scale(250.5 312.633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#672BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA572"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge4);
export default __webpack_public_path__ + "assets/media/gauge-4.0d2dd255.svg";
export { ForwardRef as ReactComponent };